import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://fretmanager.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const DEFAULTS = {
  title: 'Solution de gestion de fret international',
  description:
    'Plateforme de gestion de fret international. Suivi en temps réel, gestion des expéditions, notifications automatiques.',
  ogType: 'website',
  locale: 'fr_FR',
};

const SEOHead = ({
  title = DEFAULTS.title,
  description = DEFAULTS.description,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = DEFAULTS.ogType,
  noindex = false,
  jsonLd,
}) => {
  const fullCanonical = canonical
    ? `${SITE_URL}${canonical}`
    : undefined;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {fullCanonical && <link rel="canonical" href={fullCanonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:locale" content={DEFAULTS.locale} />
      <meta property="og:site_name" content="FretManager" />
      {fullCanonical && <meta property="og:url" content={fullCanonical} />}
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEOHead;
